module.exports = __webpack_public_path__ + "img/system-1.0ae8271.png";